import dayjs from 'dayjs';

import type { BirthDayFieldValue } from './types';

const GQL_BIRTHDATE_FORMAT = 'YYYY-MM-DD';

export const formatBirthDateIntoGqlInput = (birthDate: BirthDayFieldValue) => {
  return dayjs(`${birthDate.year}-${birthDate.month}-${birthDate.day}`).format(
    GQL_BIRTHDATE_FORMAT
  );
};
